import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehviour(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

router.beforeEach((to, from, next) => {

  // Clear any alert before route changed
  store.dispatch("alert/clear");
  
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    "/login",
    "/signup",
    "/forgot-password",
    "/lock-screen",
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next("/login");
  }

  router.afterEach(() => {
    window.scrollTo(0, 0);
  });
  next();
});

export { router };
